<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="propConfigs.length">
      <template v-for="(item) in propConfigs">
        <div class="attr-item" :key="item.attr_id">
          <el-form-item
            :prop="`${item.attr_id}`"
            :label="item.attr_name"
            :rules="rules[item.attr_id]">
            <el-select
              v-if="['1','2'].includes(item.attr_value_type)"
              :allow-create="item.support_extend === '1'"
              :multiple="item.attr_value_type === '2'"
              filterable
              :remote="['1200000088','1200000094'].includes(item.attr_id)"
              clearable
              placeholder="请完善"
              :remote-method="(query) => remoteMethod(query,item)"
              v-model="form[item.attr_id]">
              <el-option
                v-for="valueItem in item.valueList"
                :key="valueItem.valueId"
                :label="valueItem.value"
                :value="valueItem.value">
              </el-option>
            </el-select>
            
            <el-date-picker
              v-else-if="item.attr_value_type === '8'"
              v-model="form[item.attr_id]"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 188px;"
              >
            </el-date-picker>
            
            <el-input
              v-else-if="item.attr_value_type === '3'"
              v-model="form[item.attr_id]"
              :maxlength="item.text_max_length"
              placeholder="请输入"
              style="width: 188px;"
              >
            </el-input>
          </el-form-item>
        </div>
      </template>
    </template>
    <div v-else>暂无属性</div>
    <span class="update-brand">
      找不到商品属性？
      <el-link :underline="false" @click="fetchProps(true)">刷新数据</el-link>
    </span>
  </el-form>
</template>

<script>
import { getCategoryProps,getCategoryAttrValueList } from '@/servers/prod/center/mt.js'
import { mapActions } from 'vuex'

export default {
  name: 'CategoryAttributes',
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    categoryIds: {
      type: Array,
      default: () => []
    },
    shopId: {
      type: Number,
      default: ''
    },
    categoryType: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      form: {},
      propConfigs: [],
      rules: {},
      currentCategoryId: '',
      isUpdating: false,
    }
  },
  watch: {
    categoryIds: {
      handler(newVal) {
        this.currentCategoryId = newVal.length ? newVal[newVal.length - 1] : ''
      },
      immediate: true
    },
    currentCategoryId: {
      handler(newVal,oldVal) {
        if (newVal !== oldVal) {
          this.propConfigs = []
          this.rules = {}
          this.fetchProps()
        }
      },
      immediate: true
    },
    values: {
      handler(newVal) {
        if (this.isUpdating || !this.propConfigs.length) return
        
        this.isUpdating = true
        this.syncFormFromValues(newVal)
        this.$nextTick(() => {
          this.isUpdating = false
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    async fetchProps(isUpdate = false) {
      if (!this.currentCategoryId) return
      
      isUpdate && this.updateCatePropShopIndex('yyjk')
      
      try {
        const res = await getCategoryProps({ categoryId: this.currentCategoryId })
        if (res?.generalAttrs?.length) {
          this.propConfigs = res.generalAttrs.map(attr => ({
            ...attr,
            valueList: attr.valueList || JSON.parse(attr.valueListJson || '[]')
          }));
          this.initRules()
          this.syncFormFromValues(this.values)
        }
      } catch (error) {
        console.error('获取类目属性失败:', error)
      }
    },
    
    initRules() {
      const newRules = {}
      this.propConfigs.forEach(item => {
        if (item.need === '1') {
          newRules[item.attr_id] = [
            { 
              required: true, 
              message: `请完善${item.attr_name}`,
              trigger: ['1','2','8'].includes(item.attr_value_type) ? 'change' : 'blur'
            }
          ]
        }
      })
      this.rules = newRules
    },
    
    syncFormFromValues(values) {
      const newForm = {}
      
      this.propConfigs.forEach(prop => {
        const attrId = prop.attr_id
        const valueItem = values.find(v => `${v.attrId}` === `${attrId}`)
        
        if (valueItem) {
          // 处理对象类型的值
          const getActualValue = (val) => {
            if (val && typeof val === 'object' && 'value' in val) {
              return val.value
            }
            return val
          }
          
          // 处理多选和单选情况
          if (prop.attr_value_type === '2') {
            newForm[attrId] = Array.isArray(valueItem.valueList) 
              ? valueItem.valueList.map(getActualValue)
              : [getActualValue(valueItem.valueList)].filter(Boolean)
          } else {
            newForm[attrId] = Array.isArray(valueItem.valueList) 
              ? getActualValue(valueItem.valueList[0])
              : getActualValue(valueItem.valueList)
          }
        } else {
          // 设置默认空值
          newForm[attrId] = prop.attr_value_type === '2' ? [] : null
        }
      })
      
      this.form = newForm
    },
    
    emitChanges() {
      if (this.isUpdating || !this.propConfigs.length) return
      
      this.isUpdating = true
      
      const newValues = this.propConfigs.map(prop => {
        const attrId = prop.attr_id
        const formValue = this.form[attrId]
        
        // 将值转换为对象格式
        const formatValue = (val) => {
          if (!val) return null
           
          let valueId = 0;
          // 如果存在 valueList，查找匹配的选项
          if (prop.valueList && Array.isArray(prop.valueList)) {
            const matchItem = prop.valueList.find(item => item.value === val);
            if (matchItem) {
              valueId = matchItem.valueId;
            }
          }
          
          return {
            setValue: true,
            setValueId: true,
            value: val,
            valueId: valueId // 可以根据需要设置实际ID
          }
        }
        
        return {
          attrId,
          attrName: prop.attr_name,
          valueList: prop.attr_value_type === '2' 
            ? (Array.isArray(formValue) 
              ? formValue.map(formatValue) 
              : [formatValue(formValue)].filter(Boolean))
            : [formatValue(formValue)].filter(Boolean)
        }
      })
      
      this.$emit('change', newValues)
      this.$nextTick(() => {
        this.isUpdating = false
      })
    },
    async getCategoryAttrList(attr,keyword){
      let params = {
        shopId:this.shopId,
        attrId:attr.attr_id,
        keyword:keyword ||'',
        // categoryType:this.categoryType,
        // tagId:this.currentCategoryId,
        pageNum:1,
        pageSize:200
      }
      let res = await getCategoryAttrValueList(params);
      if(res && res.categoryAttrValueList){
        let map = {};
        let valueList = res.categoryAttrValueList;
        valueList.forEach(item => {
          map[item.valueId] = item;
        });
        let newValueList = Object.values(map);
        let attrObj = this.propConfigs.find(item => item.attr_id === attr.attr_id);
        attrObj.valueList = newValueList;
      }
    },
    remoteMethod(query,attr){
      if(['1200000088','1200000094'].includes(attr.attr_id)){ // 品牌、产地单独调接口获取
        this.getCategoryAttrList(attr,query)
      }
    }

  },
  created() {
    // 监听表单变化
    this.$watch(
      () => this.form,
      () => this.emitChanges(),
      { deep: true }
    )
  }
}
</script>

<style lang="scss" scoped>
.category-attr {
  align-items: flex-start;
  position: relative;
  
  .attr-item {
    width: 245px !important;
    margin-bottom: 28px !important;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
  }
  
  .update-brand {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
}
</style>